import PropTypes from "prop-types";
import { viewPhoneFromFlat } from "@shared/models/Communications/viewPhone";
import {
  callStatusIconForPhone,
  mobileCallStatusIcon,
} from "@shared/models/Communications/viewPhoneIcons/CallStatusIcon";
import BaseEvent from "../BaseEvent";

const CALL_DICTIONARY = {
  valid: "Can be Called",
  "opted-out": "Opted Out",
};

const TimelineCallSoftStatusChangeEvent = ({ event }) => {
  const timelineFields = event.timeline_fields;
  const { lead_phone_number: leadPhoneNumber, author_name: authorName, change, category } = timelineFields;
  const phone = viewPhoneFromFlat({ value: leadPhoneNumber });
  const changeSet = change.call_status;
  const dictionary = CALL_DICTIONARY;
  const finalState = dictionary[changeSet[1]];
  const callStatus = changeSet[1] === "opted-out" ? "unsubscribed" : "active";

  const callIcon =
    category === "mobile" ? mobileCallStatusIcon(callStatus) : callStatusIconForPhone(callStatus);

  return (
    <BaseEvent
      icon={callIcon.icon({ size: "l" })}
      title={
        <div>
          <span className="tw-font-bold">{authorName}</span> updated a phone status
        </div>
      }
      interactedAt={event.interacted_at_absolute}
      iconContainerClass={`${callStatus === "unsubscribed" ? "!tw-border-brivity-coral-110" : ""} tw-w-40px tw-h-40px`}
    >
      <p>
        Status of {phone.formattedNumber}{" "}
        <span className="tw-capitalize">{category ? `(${category})` : ""}</span> was updated to{" "}
        <span className={`tw-font-bold ${callStatus === "unsubscribed" ? "!tw-text-brivity-coral-110" : ""}`}>
          {finalState}
        </span>
      </p>
    </BaseEvent>
  );
};

TimelineCallSoftStatusChangeEvent.propTypes = {
  event: PropTypes.shape({
    timeline_fields: PropTypes.shape({
      lead_phone_number: PropTypes.string,
      author_name: PropTypes.string,
      category: PropTypes.string,
      change: PropTypes.shape({
        sms_status: PropTypes.arrayOf(PropTypes.string),
        call_status: PropTypes.arrayOf(PropTypes.string),
      }),
    }),
    interacted_at_absolute: PropTypes.string,
  }),
};

TimelineCallSoftStatusChangeEvent.defaultProps = {
  event: {
    timeline_fields: { lead_phone_number: "", author_name: "", change: {}, category: "" },
    interacted_at_absolute: "",
  },
};

export default TimelineCallSoftStatusChangeEvent;
